// ApiStatusBadge — compact API connectivity indicator for the top nav
// (T634). Built for the Playwright smoke spec (frontend/e2e/smoke.spec.ts)
// to have a real, stable element to assert against — mirrors LicenseBadge's
// "render nothing while loading" convention to avoid layout shift.

import { Badge } from './ui';
import { useApiStatus } from '../lib/useApiStatus';

export function ApiStatusBadge() {
  const { online, loading } = useApiStatus();

  if (loading) return null;

  return (
    <Badge
      tone={online ? 'success' : 'danger'}
      className="shrink-0"
      data-testid="api-status-badge"
      title={online ? 'API reachable (/healthz)' : 'API unreachable (/healthz)'}
    >
      {online ? 'API ONLINE' : 'API OFFLINE'}
    </Badge>
  );
}
